export default __webpack_public_path__ + "static/media/r4.dd743c1a.jpg";